import React from 'react';

import ComponentsSection from './ComponentsSection';
import ResourceSection from './ResourceSection';

export default function Component() {
  return (
    <>
      <ComponentsSection />
      <ResourceSection />
    </>
  );
}
